import type { BankAccount, PaymentCard, StripeExternalPayoutAccount, StripePaymentMethod } from '../services/paymentService';

export const formatMoney = (amount?: number | null, currency = 'USD') => {
  const value = Number(amount ?? 0);
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency || 'USD',
  }).format(value);
};

export const formatDate = (value?: string | null) =>
  value ? new Date(value).toLocaleString() : 'Not available';

export const methodLabel = (
  method: StripePaymentMethod | PaymentCard | BankAccount | StripeExternalPayoutAccount
) => {
  if ('cardNumber' in method) {
    const last4 = method.cardNumber?.slice(-4) || '----';
    return `${method.cardMerchant || method.cardType || 'Card'} ending ${last4}`;
  }
  if ('accountNumber' in method) {
    const last4 = method.accountNumber?.slice(-4) || '----';
    return `${method.bankName || 'Bank account'} ending ${last4}`;
  }
  const stripeLike = method as Partial<StripePaymentMethod & StripeExternalPayoutAccount>;
  const fallback = 'isDefault' in method || 'isDefaultPaymentAccount' in method ? 'Payout account' : 'Stripe';
  return `${stripeLike.merchant || stripeLike.bankName || stripeLike.brand || fallback} ending ${stripeLike.last4 || '----'}`;
};
